import { createSelector } from 'reselect';
import { InfiniteArray } from '../helpers/infinite-array';
import { subselect } from './root';
import { propertiesSelector } from './properties';
import { GUIDE_LIST_ITEM_KIND } from '../constants';
import { linearChannelsPropertiesSelector as linearChannelsProperties } from '../../linearChannels/selectors/properties';
import { LINEAR_CHANNELS_STATE_STATUSES } from '../../linearChannels/constants';

const isCategory = ({ kind } = {}) => kind === GUIDE_LIST_ITEM_KIND.CATEGORY;

function* getPartialList(list, firstIndex, lastIndex) {
  const infiniteList = new InfiniteArray(list);
  let currentIndex = firstIndex;
  while (currentIndex < lastIndex) {
    yield infiniteList.get(currentIndex);
    currentIndex += 1;
  }
}

const linearChannelsPropertiesSelector = (state, props, globalState) =>
  linearChannelsProperties(globalState);

const infiniteListSelector = createSelector(
  [propertiesSelector, linearChannelsPropertiesSelector],
  (
    { list = [], selectedIndex, lockSelectedAtIndex, listItemCount, skipCategoryOnFirstRow = true },
    { status, result },
  ) => {
    let finalList = [];
    if (
      list.length > 0 &&
      selectedIndex >= 0 &&
      (status === LINEAR_CHANNELS_STATE_STATUSES.DONE || result.length > 0)
    ) {
      let firstIndex = selectedIndex - lockSelectedAtIndex;
      if (isCategory(list[firstIndex]) && skipCategoryOnFirstRow) {
        firstIndex += 1;
      }
      const lastIndex = firstIndex + listItemCount;

      finalList = [...getPartialList(list, firstIndex, lastIndex)];
    }
    return finalList;
  },
);

export const guideInfiniteListSelector = subselect(infiniteListSelector);
